/**
 * Puente FM → structura-core operational (roles, permisos, nav).
 */
import type { BusinessProfile } from "@/lib/market-catalog";
import {
  resolveEffectiveOperationalAccess,
  operationalPreset,
  type ResolvedOperationalAccess,
} from "@structura/core/operational";

export type FmOperationalRoleId =
  | "owner"
  | "cashier"
  | "kitchen"
  | "delivery"
  | "branch_manager"
  | "pharmacy_counter";

export function fmOperationalAccess(
  businessProfile: BusinessProfile | string,
  operationalRoleId: string,
  planId?: string | null,
  lockedCapabilities?: string[],
): ResolvedOperationalAccess | null {
  return resolveEffectiveOperationalAccess({
    vertical: "fm",
    businessProfile,
    roleId: operationalRoleId,
    planId: planId ?? null,
    lockedCapabilities,
  });
}

export function defaultOperationalRoleForStaff(
  businessProfile: BusinessProfile | string,
): FmOperationalRoleId {
  const preset = operationalPreset("fm", businessProfile);
  const first = preset?.defaultRoles.find((r) => r !== "owner");
  return (first as FmOperationalRoleId) ?? "cashier";
}

export function navPathAllowedByOperationalAccess(
  access: ResolvedOperationalAccess | null,
  path: string,
): boolean {
  if (!access) return true;
  if (access.hiddenModules.includes(path)) return false;
  if (access.role.allowedModules.includes("*")) return true;
  return access.allowedModules.some(
    (p) => path === p || path.startsWith(`${p}/`),
  );
}
